import { useState } from "react";

import Button from "@mui/material/Button";

import { useTranslation } from "react-i18next";
import Dialog from "./Dialog";

const Add = () => {
	const { t } = useTranslation();
	const [open, setOpen] = useState(false);

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = (value) => {
		setOpen(false);
	};

	return (
		<>
			<Button variant="contained" onClick={handleClickOpen}>
				{t("add_new_user")}
			</Button>
			<Dialog open={open} onClose={handleClose} />
		</>
	);
};

export default Add;
